import React, { useState, useEffect } from 'react';

/**
 * CenterLayout 컴포넌트
 * 페이지 콘텐츠를 가운데 정렬하고, 좌우 여백을 제공하는 레이아웃 컴포넌트
 */
export default function CenterLayout({ children }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ 
      padding: isMobile ? '0.75rem' : '1.5rem',
      maxWidth: '100%'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        width: '100%'
      }}>
        {children}
      </div>
    </div>
  );
} 